export const ROOT = '/';
export const CICLO_FACTURACION = '/facturacion';
export const TOMA_LECTURA = 'toma-lectura';
export const EMISION_BOLETA = 'emision-boleta';
export const ENTREGA_BOLETA = 'entrega-boleta';
export const VENCIMIENTO_BOLETA = 'vencimiento-boleta';
export const EN_PREPARACION = 'preparacion';
export const EMITIDA = 'emitida';
export const ENTREGADA = 'entregada';
export const NO_ENTREGADA = 'no-entregada';
export const POR_VENCER = 'por-vencer';
export const PAGADA = 'pagada';
export const VENCIDA = 'vencida';
export const EN_PROCESO = 'proceso';
export const EXITO = 'exito';
export const SIN_EXITO = 'sin-exito';
export const GRUPO_SAESA_WEB_URL = 'https://web.gruposaesa.cl/';
export const HOME_PRIVADO_URL = `${process.env.REACT_APP_FUSION_AUTH_REDIRECT_URI}`;
export const LINK_PAGO = `${process.env.REACT_APP_LINK_PAGO}`;
export const ERROR_1 = 'ERROR_1';
